import React, { useState, useEffect } from 'react';
import { CloudData } from '../data/cloud-data.js';
import { Configuration } from '../data/configuration.js';
import RegionSelector from './ui/region-selector.tsx';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface HomeViewProps {
	onStartConfigurationButtonClicked: () => void;
	onLoadConfigurationButtonClicked: () => void;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export function HomeView(props: HomeViewProps) {

	// states — buttons start enabled if the data has already been loaded.
	const [enableButtons, setEnableButtons] = useState(Configuration.totalCost !== 0);

	// runs once, after initial render...
	useEffect(() => {

		// add the home page class to the body.
		document.body.classList.add('home-page');

		// load the options data from the cloud if it has not been loaded already.
		if (Configuration.totalCost === 0) {

			// load options data from the cloud.
			CloudData.loadOptions(Configuration.modelId, Configuration.regionCode, Configuration.languageCode)
				.then(() => {

					// update the costs.
					Configuration.updateCosts();

					// enable the start and load configuration buttons.
					setEnableButtons(true);

					// if the auto-start debug option has been set, click the start button.
					if (Configuration.debugOptions.autoStart) {
						props.onStartConfigurationButtonClicked();
					}
				})
				.catch(exception => {

					// log the error message.
					console.error(`Error loading data: ${exception.message}`);

					// TODO: now tell UI to display the error page!!
				});
		}

		// remove the home page class when navigating away from the page.
		return () => {
			document.body.classList.remove('home-page');
		};

		// this effect intentionally runs once on mount — the cloud data loads a single time.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// return the HTML.
	return (
		<div id="home-view">
			<div id="home-header">
				<RegionSelector />
			</div>
			<div id="home-content">
				<img src="assets/images/logo/morgan-full-logo-white.svg" width="200" height="89" alt="Morgan Motor Company Logo" />
				<p>BETA</p>
			</div>
			<div id="home-footer">
				<button type="button" id="hv-load-configuration-button" disabled={!enableButtons} onClick={props.onLoadConfigurationButtonClicked}>
					{enableButtons ? 'LOAD CONFIGURATION' : 'LOADING DATA...'}
				</button>
				<button type="button" id="hv-new-configuration-button" disabled={!enableButtons} onClick={props.onStartConfigurationButtonClicked}>
					{enableButtons ? 'NEW CONFIGURATION' : 'LOADING DATA...'}
				</button>
			</div>
		</div>
	);
}
